import { GroupIds } from "@/configuration/group-ids";

export const subotoMockEhrGroupIds: readonly string[] = [GroupIds.ENT_PARTNERS_SUBOTO_LIVE_SANDBOX];
